$(document).on("change", ".translated-input", (e) ->
  tab_id = $(this).closest(".tab-pane").attr("id")
  nav = $("a[href='#" + tab_id + "']").closest("li")

  value = $(this).val().trim()
  if value == ''
    nav.addClass("empty")
  else
    nav.removeClass("empty")

);
